module.exports = __webpack_public_path__ + "img/tr-logo-340x167.e3591595.png";